import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(theme => ({
  activityDiv: {
    height: "calc(100% - 50px)"
  }
}));

export default styles;
